import { Collapse } from 'antd'
import Section from '../common/Section'
import { Table } from 'ant-table-extensions'
import _ from 'lodash'
import { compareStrings } from '../../util/compareUtil'
import { defaultDateTime } from '../../util/dateTimeUtil'
import useRegistrations from '../../hooks/api/useRegistrations'

const flatten = (data) => _.flatMap(data, (data) => ({ id: data.id, ...data.attributes }))

const colProps = (dataIndex) => {
  return {
    sorter: (a, b) => compareStrings(_.get(a, dataIndex), _.get(b, dataIndex)),
  }
}

const RegistrationListPage = () => {
  const { registrations, loading, error } = useRegistrations()

  const columns = [
    { title: 'Row', width: '3em', fixed: 'left', dataIndex: 'id', render: (value, record, index) => <>{index + 1}</> },
    { title: 'ID', width: '3em', dataIndex: 'id', ...colProps('id') },
    { title: 'Registration number', width: '12em', dataIndex: 'registrationNumber', ...colProps('registrationNumber') },
    { title: 'State', dataIndex: 'state', ...colProps('state') },
    {
      title: 'Created at',
      dataIndex: 'createdAt',
      defaultSortOrder: 'descend',
      ...colProps('createdAt'),
      render: (text, record) => defaultDateTime(text),
    },
    { title: 'Last name', dataIndex: 'lastName', ...colProps('lastName') },
    { title: 'Email', dataIndex: 'email', ...colProps('email') },
    { title: 'Membership type', dataIndex: 'membershipType', ...colProps('membershipType') },
    { title: 'Phone', dataIndex: 'phone', ...colProps('phone') },
    { title: 'Postal code', dataIndex: 'postalCode', ...colProps('postalCode') },
    { title: 'Price', dataIndex: 'price', ...colProps('price') },
    { title: 'Street', dataIndex: 'street', ...colProps('street') },
  ]

  return (
    // <div style={{ overflowx: 'scroll' }}>
    <div>
      <Section title="Registrations">
        <b>Possible "State" values:</b>
        <ul style={{ fontSize: '10pt', paddingLeft: '2em' }}>
          <li>
            <i>"active"</i> is a normal, active registration
          </li>
          <li>
            <i>"inactive"</i> means a registration was active, but is no longer active (e.g. we refunded their
            membership fees or they were kicked out of the club)
          </li>
          <li>
            <i>"payment_pending"</i> means they used the link to avoid PayPal payment, and we're currently waiting on an
            e-transfer, cash, or cheque. The state is manually updated to "active" when we've confirmed payment. This is
            also the state of registrations for directors/coordinators until they're manually changed to "active"
            (without payment)
          </li>
          <li>
            <i>"payment_in_progress"</i> means they got to the final step of registration but did not complete payment
            via PayPal. These get manually removed after a few days.
          </li>
        </ul>
        <Table
          className="compactTable"
          scroll={{ x: 2000, y: 600 }}
          size="small"
          columns={columns}
          dataSource={flatten(registrations)}
          loading={loading}
          pagination={false}
          exportable
          exportableProps={{ showColumnPicker: true, btnProps: { type: 'link' } }}
          searchable
        />
      </Section>
    </div>
  )
}

export default RegistrationListPage
